import styled from 'styled-components';

import { buttonStylePrimary as primaryCssStyle } from '~/src/common/components/Button/Variants/PrimaryButton';
import { buttonStyleSecondary as secondaryCssStyle } from '~/src/common/components/Button/Variants/SecondaryButton';
import { COLORS } from '~/src/common/theme';

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PlusButton = styled.button<{ $size: number }>`
  ${primaryCssStyle};
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;

  border: 1.6px solid ${COLORS.ACTION_DEFAULT};
  border-radius: 4px;
`;

export const MinusButton = styled(PlusButton)`
  ${secondaryCssStyle};

  &:disabled,
  &:not(:disabled) {
    border-color: ${COLORS.NEUTRAL_STROKE};
  }
`;

export const Value = styled.span`
  width: 32px;

  font-size: 16px;
  line-height: 16px;
  font-weight: 500;
  text-align: center;
`;
